import React, { type FunctionComponent } from 'react'
import { FileUploader } from '../file-uploader/FileUploader'
import { type FileUploaderProps } from '../file-uploader/utils/fileUploader.types'
import { CsvUploaderDropArea } from './components/CsvUploaderDropArea'
import { CsvUploaderDroppedFile } from './components/CsvUploaderDroppedFile'
import { CsvUploaderError } from './components/CsvUploaderError'

export interface CsvUploaderProps {
  filestackApiKey: string
  onUpload: (file: File, url?: string) => void
  dropAreaMessages: FileUploaderProps['droppedAreaComponentMessages']
  errorMessages: FileUploaderProps['errorComponentMessages']
  className?: string
  container?: string
  region?: string
  path?: string
}

export const CsvUploader: FunctionComponent<CsvUploaderProps> = ({
  filestackApiKey,
  onUpload,
  className,
  dropAreaMessages,
  errorMessages,
  container,
  region,
  path,
}) => (
  <FileUploader
    uploadToFilestack
    filestackApiKey={filestackApiKey}
    onUpload={onUpload}
    validateFile={file => {
      if (file.type !== 'text/csv') {
        return 'fileTypeError'
      }

      return null
    }}
    DropAreaComponent={CsvUploaderDropArea}
    DroppedFileComponent={CsvUploaderDroppedFile}
    ErrorComponent={CsvUploaderError}
    className={className}
    droppedAreaComponentMessages={dropAreaMessages}
    errorComponentMessages={errorMessages}
    container={container}
    region={region}
    path={path}
  />
)
